const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-90d511fd-dad4-4520-889f-d70592c06279",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-2a90cd18-2c25-4fb1-ad5c-7c95844e2212",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    style: {
      strokeWidth: 0
    },
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.86,16.47l7.29-8.47h-1.73l-6.33,7.35-5.05-7.35h-5.83l7.64,11.12-7.64,8.88h1.73l6.68-7.76,5.33,7.76h5.83l-7.92-11.53h0Zm-2.37,2.73l-.77-1.11-6.16-8.81h2.65l4.97,7.11.77,1.11,6.46,9.24h-2.65l-5.27-7.54h0Z",
    style: {
      strokeWidth: 0
    },
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitter-black.4af29ebb.svg";
export { ForwardRef as ReactComponent };